import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';

import { SubscriptionPlan, SubscriptionStatus } from '@vi-iot/client';

import { BookingSubscription, UserDetailsStore } from '@store';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { PillComponent } from '@components';
import { ViIconComponent, ViItemComponent } from '@vi-iot/ui/index';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { PillType } from '../../../../shared/components/pill/pill.model';
import { matTooltipSetter } from '../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';
import { SearchService } from '../../../search.service';
import { CancelBookingDirective } from '@directives';

@Component({
  selector: 'app-package-per-installation-row',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    MatIconModule,
    MatTooltipModule,
    ViIconComponent,
    ViItemComponent,
    CancelBookingDirective,
    PillComponent,
    MatMenuModule,
  ],
  templateUrl: './package-per-installation-row.component.html',
  styleUrls: ['./package-per-installation-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackagePerInstallationRowComponent implements OnInit, OnChanges {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() subscription: BookingSubscription;

  readonly subscriptionsStatusType = SubscriptionStatus;
  readonly subscriptionPlan = SubscriptionPlan;
  readonly pillType = PillType;

  leftDays: string;
  title: string;
  isCancelMenuVisible: boolean;

  constructor(private searchService: SearchService, public userDetailsStore: UserDetailsStore) {}

  ngOnChanges(): void {
    this.title = this.searchService.getBookingDateLabel(this.subscription);
    this.isCancelMenuVisible = this.searchService.isCancellingPackagePossible(this.subscription);
  }

  ngOnInit(): void {
    this.leftDays = this.searchService.getLeftDays(this.subscription?.expirationDate);
  }
}
